import { useEffect } from "react";

export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => {
      try { document.head.removeChild(meta); } catch {}
    };
  }, []);
}